module.exports = __webpack_public_path__ + "front/img/c2.68943a34.png";